import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css' // optional

export default Tippy
